import type { AppThunk } from "../";
import { CustomError, PageEnvelope } from "@skv/core";

import { Organisation } from "./reducer";

export const fetchOrganisation = (
  orgId: string
): AppThunk<Promise<Organisation | CustomError>> => async (
  dispatch,
  getState
): Promise<Organisation | CustomError> => {
  if (!orgId) {
    throw Error("No organisationId passed as argument.");
  }

  const currentState = getState();
  const cachedResult = currentState.organisation.data[orgId];

  if (cachedResult) {
    if (cachedResult instanceof CustomError) {
      dispatch({
        type: "ORGANISATION:FETCH:ERROR",
        payload: {
          id: orgId,
          error: cachedResult,
        },
      });
      return;
    }

    dispatch({
      type: "ORGANISATION:FETCH:END:FROMCACHE",
      payload: {
        data: cachedResult,
      },
    });

    return cachedResult;
  }

  dispatch({
    type: "ORGANISATION:FETCH:START",
  });

  return fetch(`/api/organisation/${orgId}`)
    .then<PageEnvelope<{ organisation: Organisation }>>((res) => {
      if (res.ok) {
        return res.json();
      }

      throw new CustomError(
        "Response from server was not 200",
        "error:organisation"
      );
    })
    .then(({ data, errorCode, errorMessage, success }) => {
      if (success) {
        dispatch({
          type: "ORGANISATION:FETCH:END",
          payload: {
            data: data.organisation,
          },
        });

        return data.organisation;
      }

      dispatch({
        type: "ORGANISATION:FETCH:ERROR",
        payload: {
          id: orgId,
          error: new CustomError(errorMessage, errorCode),
        },
      });
    })
    .catch((err: CustomError) => {
      dispatch({
        type: "ORGANISATION:FETCH:ERROR:UNKNOWN",
        payload: {
          error: err,
        },
      });

      return err;
    });
};

export const resetErrors = () => ({
  type: "ORGANISATION:ERROR:RESET",
});
